import Individualfreezone from './Individualfreezone';

export default Individualfreezone;